import { Component, h } from "preact";

import { Icon } from "../../Icon";

export function LogoIcon(rest) {
  return (
    <Icon {...rest}>
      <path
        d="M0 25C0 11.1929 11.1929 0 25 0V0C38.8071 0 50 11.1929 50 25V25C50 38.8071 38.8071 50 25 50V50C11.1929 50 0 38.8071 0 25V25Z"
        fill="black"
      />
      <path
        d="M25 7.34985L29.867 19.0516L42.5 20.0643L32.875 28.3092L35.8156 40.6368L25 34.0307L14.1844 40.6368L17.125 28.3092L7.5 20.0643L20.133 19.0516L25 7.34985Z"
        fill="white"
      />
    </Icon>
  );
}
